!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,(function(){"use strict";function n(){return n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n},n.apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),a=t&&window.devicePixelRatio>1,r={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1,restore_on_error:!1},c=function(t){return n({},r,t)},l=function(n,t){var e,i="LazyLoad::Initialized",o=new n(t);try{e=new CustomEvent(i,{detail:{instance:o}})}catch(n){(e=document.createEvent("CustomEvent")).initCustomEvent(i,!1,!1,{instance:o})}window.dispatchEvent(e)},u="src",s="srcset",d="sizes",f="poster",_="llOriginalAttrs",g="data",v="loading",b="loaded",m="applied",p="error",h="native",E="data-",I="ll-status",y=function(n,t){return n.getAttribute(E+t)},k=function(n){return y(n,I)},w=function(n,t){return function(n,t,e){var i="data-ll-status";null!==e?n.setAttribute(i,e):n.removeAttribute(i)}(n,0,t)},A=function(n){return w(n,null)},L=function(n){return null===k(n)},O=function(n){return k(n)===h},x=[v,b,m,p],C=function(n,t,e,i){n&&(void 0===i?void 0===e?n(t):n(t,e):n(t,e,i))},N=function(n,t){o?n.classList.add(t):n.className+=(n.className?" ":"")+t},M=function(n,t){o?n.classList.remove(t):n.className=n.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},z=function(n){return n.llTempImage},T=function(n,t){if(t){var e=t._observer;e&&e.unobserve(n)}},R=function(n,t){n&&(n.loadingCount+=t)},G=function(n,t){n&&(n.toLoadCount=t)},j=function(n){for(var t,e=[],i=0;t=n.children[i];i+=1)"SOURCE"===t.tagName&&e.push(t);return e},D=function(n,t){var e=n.parentNode;e&&"PICTURE"===e.tagName&&j(e).forEach(t)},H=function(n,t){j(n).forEach(t)},V=[u],F=[u,f],B=[u,s,d],J=[g],P=function(n){return!!n[_]},S=function(n){return n[_]},U=function(n){return delete n[_]},$=function(n,t){if(!P(n)){var e={};t.forEach((function(t){e[t]=n.getAttribute(t)})),n[_]=e}},q=function(n,t){if(P(n)){var e=S(n);t.forEach((function(t){!function(n,t,e){e?n.setAttribute(t,e):n.removeAttribute(t)}(n,t,e[t])}))}},K=function(n,t,e){N(n,t.class_applied),w(n,m),e&&(t.unobserve_completed&&T(n,t),C(t.callback_applied,n,e))},Q=function(n,t,e){N(n,t.class_loading),w(n,v),e&&(R(e,1),C(t.callback_loading,n,e))},W=function(n,t,e){e&&n.setAttribute(t,e)},X=function(n,t){W(n,d,y(n,t.data_sizes)),W(n,s,y(n,t.data_srcset)),W(n,u,y(n,t.data_src))},Y={IMG:function(n,t){D(n,(function(n){$(n,B),X(n,t)})),$(n,B),X(n,t)},IFRAME:function(n,t){$(n,V),W(n,u,y(n,t.data_src))},VIDEO:function(n,t){H(n,(function(n){$(n,V),W(n,u,y(n,t.data_src))})),$(n,F),W(n,f,y(n,t.data_poster)),W(n,u,y(n,t.data_src)),n.load()},OBJECT:function(n,t){$(n,J),W(n,g,y(n,t.data_src))}},Z=["IMG","IFRAME","VIDEO","OBJECT"],nn=function(n,t){!t||function(n){return n.loadingCount>0}(t)||function(n){return n.toLoadCount>0}(t)||C(n.callback_finish,t)},tn=function(n,t,e){n.addEventListener(t,e),n.llEvLisnrs[t]=e},en=function(n,t,e){n.removeEventListener(t,e)},on=function(n){return!!n.llEvLisnrs},an=function(n){if(on(n)){var t=n.llEvLisnrs;for(var e in t){var i=t[e];en(n,e,i)}delete n.llEvLisnrs}},rn=function(n,t,e){!function(n){delete n.llTempImage}(n),R(e,-1),function(n){n&&(n.toLoadCount-=1)}(e),M(n,t.class_loading),t.unobserve_completed&&T(n,e)},cn=function(n,t,e){var i=z(n)||n;on(i)||function(n,t,e){on(n)||(n.llEvLisnrs={});var i="VIDEO"===n.tagName?"loadeddata":"load";tn(n,i,t),tn(n,"error",e)}(i,(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_loaded),w(t,b),C(e.callback_loaded,t,i),o||nn(e,i)}(0,n,t,e),an(i)}),(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_error),w(t,p),C(e.callback_error,t,i),e.restore_on_error&&q(t,B),o||nn(e,i)}(0,n,t,e),an(i)}))},ln=function(n,t,e){!function(n){return Z.indexOf(n.tagName)>-1}(n)?function(n,t,e){!function(n){n.llTempImage=document.createElement("IMG")}(n),cn(n,t,e),function(n){P(n)||(n[_]={backgroundImage:n.style.backgroundImage})}(n),function(n,t,e){var i=y(n,t.data_bg),o=y(n,t.data_bg_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage='url("'.concat(r,'")'),z(n).setAttribute(u,r),Q(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_multi),o=y(n,t.data_bg_multi_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage=r,K(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_set);if(i){var o=i.split("|"),a=o.map((function(n){return"image-set(".concat(n,")")}));n.style.backgroundImage=a.join(),""===n.style.backgroundImage&&(a=o.map((function(n){return"-webkit-image-set(".concat(n,")")})),n.style.backgroundImage=a.join()),K(n,t,e)}}(n,t,e)}(n,t,e):function(n,t,e){cn(n,t,e),function(n,t,e){var i=Y[n.tagName];i&&(i(n,t),Q(n,t,e))}(n,t,e)}(n,t,e)},un=function(n){n.removeAttribute(u),n.removeAttribute(s),n.removeAttribute(d)},sn=function(n){D(n,(function(n){q(n,B)})),q(n,B)},dn={IMG:sn,IFRAME:function(n){q(n,V)},VIDEO:function(n){H(n,(function(n){q(n,V)})),q(n,F),n.load()},OBJECT:function(n){q(n,J)}},fn=function(n,t){(function(n){var t=dn[n.tagName];t?t(n):function(n){if(P(n)){var t=S(n);n.style.backgroundImage=t.backgroundImage}}(n)})(n),function(n,t){L(n)||O(n)||(M(n,t.class_entered),M(n,t.class_exited),M(n,t.class_applied),M(n,t.class_loading),M(n,t.class_loaded),M(n,t.class_error))}(n,t),A(n),U(n)},_n=["IMG","IFRAME","VIDEO"],gn=function(n){return n.use_native&&"loading"in HTMLImageElement.prototype},vn=function(n,t,e){n.forEach((function(n){return function(n){return n.isIntersecting||n.intersectionRatio>0}(n)?function(n,t,e,i){var o=function(n){return x.indexOf(k(n))>=0}(n);w(n,"entered"),N(n,e.class_entered),M(n,e.class_exited),function(n,t,e){t.unobserve_entered&&T(n,e)}(n,e,i),C(e.callback_enter,n,t,i),o||ln(n,e,i)}(n.target,n,t,e):function(n,t,e,i){L(n)||(N(n,e.class_exited),function(n,t,e,i){e.cancel_on_exit&&function(n){return k(n)===v}(n)&&"IMG"===n.tagName&&(an(n),function(n){D(n,(function(n){un(n)})),un(n)}(n),sn(n),M(n,e.class_loading),R(i,-1),A(n),C(e.callback_cancel,n,t,i))}(n,t,e,i),C(e.callback_exit,n,t,i))}(n.target,n,t,e)}))},bn=function(n){return Array.prototype.slice.call(n)},mn=function(n){return n.container.querySelectorAll(n.elements_selector)},pn=function(n){return function(n){return k(n)===p}(n)},hn=function(n,t){return function(n){return bn(n).filter(L)}(n||mn(t))},En=function(n,e){var o=c(n);this._settings=o,this.loadingCount=0,function(n,t){i&&!gn(n)&&(t._observer=new IntersectionObserver((function(e){vn(e,n,t)}),function(n){return{root:n.container===document?null:n.container,rootMargin:n.thresholds||n.threshold+"px"}}(n)))}(o,this),function(n,e){t&&(e._onlineHandler=function(){!function(n,t){var e;(e=mn(n),bn(e).filter(pn)).forEach((function(t){M(t,n.class_error),A(t)})),t.update()}(n,e)},window.addEventListener("online",e._onlineHandler))}(o,this),this.update(e)};return En.prototype={update:function(n){var t,o,a=this._settings,r=hn(n,a);G(this,r.length),!e&&i?gn(a)?function(n,t,e){n.forEach((function(n){-1!==_n.indexOf(n.tagName)&&function(n,t,e){n.setAttribute("loading","lazy"),cn(n,t,e),function(n,t){var e=Y[n.tagName];e&&e(n,t)}(n,t),w(n,h)}(n,t,e)})),G(e,0)}(r,a,this):(o=r,function(n){n.disconnect()}(t=this._observer),function(n,t){t.forEach((function(t){n.observe(t)}))}(t,o)):this.loadAll(r)},destroy:function(){this._observer&&this._observer.disconnect(),t&&window.removeEventListener("online",this._onlineHandler),mn(this._settings).forEach((function(n){U(n)})),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount},loadAll:function(n){var t=this,e=this._settings;hn(n,e).forEach((function(n){T(n,t),ln(n,e,t)}))},restoreAll:function(){var n=this._settings;mn(n).forEach((function(t){fn(t,n)}))}},En.load=function(n,t){var e=c(t);ln(n,e)},En.resetStatus=function(n){A(n)},t&&function(n,t){if(t)if(t.length)for(var e,i=0;e=t[i];i+=1)l(n,e);else l(n,t)}(En,window.lazyLoadOptions),En}));

function save_country(country){
	window.location.href = "/en/?cCode="+country;
}

// tomas - contact-us expandable blocks
jQuery('.click_to_expand').on('click', function(){
	jQuery(this).next().slideToggle();
});



jQuery(document).ready(function(){  	
		if(jQuery('#freeship').val() == 1){
		$('#myModal').modal('show');
	}
	
	
	// tomas - remove from all - requested by Kathy
	jQuery('.mega-menu a[href*="easter-chocolates"]').remove();  // Easter
	//jQuery('.mega-menu a[href*="Christmas"]').remove();  // Anything containing "Christmas" in HREF
	//jQuery('.mega-menu a[href*="christmas"]').remove();  // Anything containing "christmas" in HREF
	jQuery('.mega-menu a[href*="valentines"]').remove();  // Anything containing "valentines" in HREF
	jQuery('.mega-menu a[href*="blackfriday"]').remove();  // Anything containing "blackfriday" in HREF
	jQuery('.mega-menu a[href*="Fathers-Day-Chocolates"]').remove(); // Father's Day Chocolates
	
	
	// tomas - removing menu items based on country
	country_code = $('#country_code_hidden').val();
	
	if (country_code == '99'){
		<!-- Ireland -->
		jQuery('.mega-menu a[href*="mothers-day-chocolates"]').remove(); // Mother's Day Chocolates
	}

	if (country_code == '164'){
		<!-- New Zaeland -->
		
		jQuery('.mega-menu a[href*="Christmas"]').remove();  // Anything containing "Christmas" in HREF
		jQuery('.mega-menu a[href*="christmas"]').remove();  // Anything containing "christmas" in HREF
		jQuery('.mega-menu a[href*="mothers-day-chocolates"]').remove(); // Mother's Day Chocolates
		jQuery('.mega-menu a[href*="powder-puff"]').remove(); // The Powder Puff Collection
		jQuery('.top-bar__actions a').text('Account Create|Login');
	}

	if (country_code == '223'){
		<!-- USA -->
		jQuery('.mega-menu a[href*="mothers-day-chocolates"]').remove(); // Mother's Day Chocolates
	}
	
	if (country_code == '75'){
		<!-- UK -->
		jQuery('.mega-menu a[href*="mothers-day-chocolates"]').remove(); // Mother's Day Chocolates
	}
	
	if(jQuery('#acustom_14').length){
		jQuery("label[for='acustom_14']").text('Add a personal message:');
		jQuery("#acustom_14").attr('placeholder','your message');
	}
	
	
	// tomas - country dropdown hiding
	jQuery('.currency_dropdown').on('click',function(event){
		if (event.target !== this)
    	return;
		jQuery(this).hide();
	});
	
	// tomas - country dropdown showing
	jQuery('.dropdown-toggle').on('click',function(event){
		if($(this).attr('id') == 'countryList'){
			jQuery('.currency_dropdown').show();
		}
	});
	
	/*$('.payment_methods>div:nth-child(2) .btn-primary').remove();  // Tomas - removing PayPal express payment button from checkout
	//$('.payment_methods>div:nth-child(2) p').html('<img src="https://www.butlerschocolates.com/themes/637/Butlers country popup March 2020/images/assets/pay-paypalexpress.jpg?v=2" width="130"><br>For Secure PayPal Checkout powered by PayPal Express, please go back to your cart and choose the PayPal option.<br><br><a href="https://www.butlerschocolates.com/eshop/cart/" class="btn btn-lg btn-m-sm btn-chocolate">< back to cart </a>');  // Tomas - Adding PayPal Express instructions*/
	
	jQuery(document).on('zg.product.addedToCart',function(){
		$("#cart-items").show(500);
		
		$("html, body").stop().animate({scrollTop:0}, 500, 'swing');

		setTimeout(function(){
			$("#cart-items").hide(500);
		},5000);
	});
	jQuery("#unitegallery").unitegallery();
	
	if (document.cookie.indexOf('countrySelected') == -1 ) {
		if((COUNTRY_BY_IP !=14 && COUNTRY_BY_CURRENCY != 164) || (COUNTRY_BY_IP !=164 && COUNTRY_BY_CURRENCY != 14)) {
		if(COUNTRY_BY_IP != COUNTRY_BY_CURRENCY) {
			var availableCountries = ["99","223","164","75"];
			$('.country_by_ip').text(COUNTRIES[COUNTRY_BY_IP]);
			$('.current_store').text(COUNTRIES[COUNTRY_BY_CURRENCY]);
			if(availableCountries.indexOf(COUNTRY_BY_IP)>-1) {
				$('.better_store').text(COUNTRIES[COUNTRY_BY_IP]);
				$('a.new-store').data('store', COUNTRY_BY_IP);	
			} else {
				$('.better_store').text('IRELAND')
				$('a.new-store').data('store', 99);	
			}
			$('a.same-store').data('store', COUNTRY_BY_CURRENCY);	
			$('#country_modal').modal('show');
		}
		}
	}
	
	
	$('.new-store, .same-store').click(function() {
		document.cookie = "countrySelected=true; expires=Thu, 18 Dec 2018 12:00:00 UTC";
		switch($(this).data('store')) {
			case "99":
				var loc = "/en/?cCode=ie";
			break;
			case "223":
				var loc = "/en/?cCode=us";
			break;
			case "164":
				var loc = "/en/?cCode=nz";
			break;
			case "75":
				var loc = "/en/?cCode=gb";
			break;
		}
		window.location = loc;
		return false;
	})
	
	// base hamper object
	hamper = {
		id: $('#hamper_product_id').val(),
		products: {},
		volume: 11760,
		volumeFilled: 0,
		price: parseFloat($('.hamper-value').data('base-price'))
	}
	
	// set to empty
	setProgressMessage('empty');
	
	$('.hamper-value').text(hamper.price.toFixed(2));
	
	$('.checkout-hamper').click(function() {
		console.log('checkout click');
		hamper_items = {};
		x=0;
		$.each( hamper.products, function( key, value ) {
			hamper_items[x] = {
				product_id: key,
				sku: 0,
				quantity: value.qty,
				title: value.title
			}
			x++;
		});
		if(x<1)
		{
			console.log('x--->'+x);
			console.log(hamper.products);			
			$('#myModalhamper').modal('show');
			return false;
		}
		aCustom = [
			{
				"customization_id": 20,
				"customization_value": JSON.stringify(hamper_items)
			}
		];
																
		$.post('/eshop/eshop/action/addProductToCart/', {product_id: hamper.id, sku: 0, quantity: 1, aCustom: aCustom}, function(res) {
			console.log(res)
			$.post('/eshop/eshop/action/addProductToCart/', {items: hamper_items}, function(res) {
			 console.log(res)
			 window.location = '/eshop/cart/';
			})
		})
		return false;
	})
	
	// show overlay
	$('body').on('mouseenter', '.hamper-page .panel', function() {
		var productId = $(this).data('id');
		$overlay = $('<div class="hamper-product-overlay"></div>')
			.append('<span class="hamper-qty">0</span> in hamper<br>')
			.append(' <button class="hamper-add">ADD</button></div>')
			// .append(' <button class="hamper-remove">REMOVE</button> </div>');
		$(this).append($overlay);
		setProductButtons(productId);
	})
	
	// hide overlay
	$('body').on('mouseleave', '.hamper-page .panel', function() {
		$(this).find('.hamper-product-overlay').remove();
	})
	
	// remove hamper item
	$('body').on('click', '.hamper-remove', function() {
			var product = $(this).parents('article')
			var productId = product.data('id');
			var productVolume = calculateProductVolume(product);
			hamper.volumeFilled -= productVolume;
			var price = product.find('.to-sell').data('price').explode(' ');
			hamper.price -= parseFloat(price[1].substr(2));
		  removeAllHamperProducts(product);
			hamper.products[productId].qty--;
			if(hamper.products[productId].qty == 0) {
				$('.hamper-remove[data-id="'+productId+'"]').triggerClick();
			}
			setProductButtons(productId);
			setProgress(hamper.products);
	});
	
	$('body').on('click', '.hamper-remove-all', function() {
		var productId = $(this).data('id');
		hamper.volumeFilled -= hamper.products[productId].volume;
		hamper.price -= hamper.products[productId].price;
		delete(hamper.products[productId]);
		setProgress(hamper);
		setSidebar(hamper.products)
		
	});
	

	// add hamper item
	$('body').on('click', '.hamper-add', function(event) {
		event.preventDefault();
		var product = $(this).parents('article');
		var productId = product.data('id');
		var productVolume = calculateProductVolume(product);
		var tmpVol = hamper.volumeFilled + productVolume;
		if(tmpVol>hamper.volume) {
			$('#hamperFullModal').modal('show');
		} else {
			hamper.volumeFilled = tmpVol;
			var price = product.find('.to-sell').data('price');
			price = parseFloat(price.replace('$', '').replace('€', '').replace('£', ''));
			
			hamper.price += price;
			if(hamper.products[productId]) {
				hamper.products[productId].qty++;
				hamper.products[productId].price+=price;
				hamper.products[productId].volume+=productVolume;
			} else {
				title = product.find('.name a').text();
				hamper.products[productId]= { qty: 1, price: price, title: product.find('.name a').attr('title'), volume: productVolume};
			}
			setProductButtons(productId);
			setProgress(hamper);
			setSidebar(hamper.products)
		}
	});
	
	function setProgress(hamper) {
		var percent = (hamper.volumeFilled/hamper.volume)*100;
		$('.hamper-progress-current').animate({ width: percent + '%'});
		$('.hamper-value').text(hamper.price.toFixed(2));
		if(percent==100) {
			setProgressMessage('full');
		} else {
			setProgressMessage('empty');
		}
	}
	
	function setSidebar(products) {
		$('.hamper-sidebar .hamper-items').html('');
		$.each(products, function(key,product) {
			$('.hamper-sidebar .hamper-items').append('<p>' + product.qty+ ' x ' + product.title + ' <a class="hamper-remove-all" data-id="'+key+'"><i class="fa fa-times"></i></a></p>')			
		})
	}
	

	function calculateProductVolume(product) {
		return product.data('width')*product.data('height')*product.data('depth');
	}
	
	function setProgressMessage(state) {
		$('.hamper-progress-message').text($('.hamper-progress-message').data(state));
	}
	
	function setProgressBar(percentage) {
		$('.hamper-progress-current').animate({width: percentage+'%'})
		if(hamperCompletion>=100) {
				hamperCompletion=100;
				setProgressMessage('full');
			} else {
				setProgressMessage('empty');
				
			}
	}
	
	function setProductButtons(productId) {
		if(hamper.products[productId]) {
			// $('.hamper-remove').show();
			$('.hamper-qty').text(hamper.products[productId].qty);
		} else {
			$('.hamper-remove').hide();
			$('.hamper-qty').text(0);
		}
	}
	

	
if($(window).width() <= 768){   
    $('.bxsliderNew').flexslider({
    animation: "slide",
    animationLoop: false,
    itemWidth: 200,
    minItems: 1,
		maxItems: 1,
  });
}   
    

    //slider = $('.bxslider').bxSlider();
//slider.destroySlider();
    
    if ($.fn.reflect) {
        $('#preview-coverflow .cover').reflect();   // only possible in very specific situations
    }
		jQuery('.coverflowPara').hide();
    jQuery('#preview-coverflow').coverflow({
        //index:           jQuery('#preview-coverflow').find('img').length/2,
			index: 0,
        density:        2,
        innerOffset:    50,
        innerScale:     .7,
        animateStep:    function(event, cover, offset, isVisible, isMiddle, sin, cos) {
            if (isVisible) {
                if (isMiddle) {
                    $(cover).css({
                        'filter':           'none',
                        '-webkit-filter':   'none'
                    });
                } else {
                    var brightness  = 1 + Math.abs(sin),
                        contrast    = 1 - Math.abs(sin),
                        filter      = 'contrast('+contrast+') brightness('+brightness+')';
                    $(cover).css({
                        'filter':           filter,
                        '-webkit-filter':   filter
                    });
                }
            }
					
        },
			animateComplete: function(){
				jQuery('.coverflowPara').hide();
				jQuery('.cover').each(function(i){
					if(jQuery(this).hasClass('current')){
						jQuery('.coverflowPara').eq(i).show();
					}
				});
				console.log('animateComplete');
			}

			 
    });
});

jQuery(window).load(function(){
    var $window;
    var $headerTop;

    // normal || fixed
    var desktopFixedState = 'normal';
    //$(document).ready(init);
    function init() {
        $window = $(window);
        $headerTop = $('.header-top').parent();

        $window.on('scroll', _.throttle(checkFixedHeader, 33));
        if ($headerTop.length) checkFixedHeader();
			
			
			
			if(isMobile()){				
        $('[data-mega-target]').on('click', showMegaMenu);
			}else{
				//
			}
                $('[data-mega-target]').on('mouseenter', showMegaMenu);
        $('.mega-menu__wrap').on('mouseleave', hideMegaMenu);
        $('.mega-menu__m-back').on('click', hideMegaMenu);
        $('.m-menu-icon').on('click', openMobileMenu);
        $('.m-header-close').on('click', closeMobileMenu);
        //bxSlider();
        checkAnimateHeaderIn();
        
    }
		
function isMobile(){
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	
	//console.log("check === "+check);
  return check;
};

    function checkFixedHeader() {
      var headerTopHeight = $headerTop.outerHeight();

        // desktop
			if ($headerTop.offset()) {
        var offset = $headerTop.offset().top - $window.scrollTop() + headerTopHeight;

        // only touch dom if state has changed
        if (offset <= 0 && desktopFixedState !== 'fixed') {
            // fixed on desktop
            $('body').addClass('fixed-menu');
            desktopFixedState = 'fixed';
        } else if (offset > 0 && desktopFixedState !== 'normal') {
            // normal on desktop
            $('body').removeClass('fixed-menu');
            desktopFixedState = 'normal';
        }
			}
    }

    // same for desktop and mobile
    function showMegaMenu(e) {
             e.preventDefault();

        var $this = $(this);
        var target = $this.attr('data-mega-target');
        //console.log($('[data-mega-name="' + target + '"]').length);
       if(! $('[data-mega-name="' + target + '"]').length){
       	 //	console.log("jj");
       	 $('body').removeClass('mega-menu-open');
       	 $('.mega-menu__item')
            .filter('[data-mega-name="' + target + '"]')
            .removeClass('active');
       		return;
       }

        // change mega menu content
        $('.mega-menu__item')
            .removeClass('active')
            .filter('[data-mega-name="' + target + '"]')
            .addClass('active');

        if(!$('body').hasClass('mega-menu-open')) $('body').addClass('mega-menu-open');
    }

    // same for desktop and mobile
    function hideMegaMenu() {           
        $('body').removeClass('mega-menu-open');
    }

    function openMobileMenu() {
        $('body').addClass('mobile-menu-open');
    }

    function closeMobileMenu() {
        $('body').removeClass('mobile-menu-open');
    }

    // only animates once per user
    function checkAnimateHeaderIn() {
        var homeAnimPlayed = Cookies.get('home-anim-played');

        // normal check
        // if(!$('header').hasClass('header--has-bg') || homeAnimPlayed === '1' || $(window).width() < 767) return;

        // just for testing, animated all the time on desktop
        // if(!$('header').hasClass('header--has-bg')  || $(window).width() < 767) return;
        if(!$('header').hasClass('header--has-bg')) return;

        animateHomeIntro();

        Cookies.set('home-anim-played', '1');
    }

    function animateHomeIntro() {
				
			$('body').addClass('header-intro-anim--pt1');
			$('body').addClass('header-intro-anim--pt2');
			
				return;
			
        $('html, body').scrollTop(0);
        $('body').addClass('header-intro-anim');

        setTimeout(function(){
            $('body').addClass('header-intro-anim--pt1');
        }, 800);

        setTimeout(function(){
            $('body').addClass('header-intro-anim--pt2');
        }, 2000);
    }
    init();


    

});

(function($){

    var $els;
    var defaultBuffer = $(window).width() > 480 ? 100 : 50;

    $(document).ready(init);

    function init(){
			/*	aplayed = Cookies.get('home-anim-played');
			if(typeof(aplayeds) !== 'undefined'){
				if(aplayed == 1){
					$('.on-visible-show').addClass('on-visible-show--is-visible');
					$('body').addClass('header-intro-anim--pt1').addClass('header-intro-anim--pt2');
				}
			}*/
        $els = $('.on-visible-show');

        if($els.length === 0) return;

        checkVisible();
        $(window).on('scroll.visible', _.throttle(checkVisible, 100));
        // $els.imagesLoaded({background: true}, function(){
        //  checkVisible();
        // });
    }

    function checkVisible(){
        $els.each(function(){
            var $this = $(this);

            if($this.css('display') === 'none') return;

            if($this.hasClass('on-visible-show--is-visible')) return;

            var visible = isVisible($this);

            if(visible){
                $this.addClass('on-visible-show--is-visible');
            }
        });
    }

    window.isVisible = isVisible;
    function isVisible($el, buffer){
        buffer = buffer || defaultBuffer;

        var windowHeight = $(window).height();
        var scrollTop = $(window).scrollTop();
        var offsetTop = $el.offset().top + buffer;
        var elHeight = $el.height();

        return ((offsetTop < (windowHeight + scrollTop)) && (offsetTop > (scrollTop - elHeight)));
    }
    init();
    
})(jQuery);

function initialize(url){
	// alert(url);
};


$( document ).ready(function() {
	
	$('#qr_code').qrcode({width: 130,height: 130,text: $('#fidelity-info-cardCode').text()});
	$('#qr_code_zoom').qrcode({width: 300,height: 300,text: $('#fidelity-info-cardCode').text()});		
	
	$( "#downloadqr" ).on('click', function(){
			var canvas = document.getElementById('qr_code_zoom').querySelector('canvas');
  		var dataURL = canvas.toDataURL();
		  var w = window.open('about:blank');
		  w.document.write("<img src='" + dataURL + "' />");
	});
	
	if(sessionStorage.getItem("isfedility") == 'true') {
		$('#happiness_card_tab').trigger('click');
		sessionStorage.removeItem("isfedility");
	}
	if(sessionStorage.getItem("isfedilitycart") == 'true') {
		$('#use_fidelity_card_checkbox').trigger('click');
		sessionStorage.removeItem("isfedilitycart");
	}	
	$('img[src="https://www.butlerschocolates.com/themes/637/Butlers country popup June 2019/images/assets/pay-paypalexpress.jpg?v=2"]').attr('src','https://www.butlerschocolates.com/themes/637/Butlers%20country%20popup%20June%202019/images/paypal.png');
	
	
	$( "#filter-maindiv .close a" ).on('click', function(){
		$('#filter-btn-toggle').trigger('click');
	});

	var SELECTOR = $( '[data-zg-role="payment-stripe"]' );
	
	if( SELECTOR.length > 0 ){
		// Create a Stripe client
    var stripe = Stripe( PUBLIC_KEY );

    // Create an instance of Elements
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
        base: {
            color: '#32325d',
            lineHeight: '18px',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        }
    };

    // Create an instance of the card Element
		if( ZG_CONFIG.shippingAddressCountryId == '99'){
			var card = elements.create('card', {style: style, hidePostalCode: true});
		}
		else{
			var card = elements.create('card', {style: style});
		}

    // Add an instance of the card Element into the `card-element` <div>
    card.mount('#card-element');

    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    // Handle form submission
    var form = document.getElementById('payment-form');
    var completeButton = document.getElementById("stripe-complete-payment");
    var stripeToken =  document.getElementById("stripe-token");

    completeButton.addEventListener('click', function(e){
				completeButton.disabled = true;
				//console.log("disabled");
        e.preventDefault();

        stripe.createToken(card).then(function(result) {
            if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
								completeButton.disabled = false;
								//console.log("enabled");
            } else {
                // Send the token to your server
                stripeToken.value = JSON.stringify(result.token);
                form.submit();
            }

        });
    });
	}

$(function($) {
	var LazyLoadInstance = new LazyLoad({ event:"lazyLoaded"});

	$(document).on('zg.getProductInfo.productCreated' ,function(){
		LazyLoadInstance.update();
	});

	/*
    $("img.lazy").Lazy({ event:"lazy-loaded"});
	
	$('img.lazy').on('lazy-loaded',function(){
		$('.slick-slider').slick('refresh');
	});
	*/
	// Set the options globally
  // to make LazyLoad self-initialize
  window.lazyLoadOptions = {
    // Your custom settings go here
  };
  // Listen to the initialization event
  // and get the instance of LazyLoad
  window.addEventListener(
    "LazyLoad::Initialized",
    function (event) {
      window.lazyLoadInstance = event.detail.instance;
    },"LazyLoad::Initialized",
    function (event) {
      window.lazyLoadInstance = event.detail.instance;
    },
    false
  );
  $(".slick-slider").on( 
		"classChanged", function () {
			console.log('class CHANGED'); 
	}); 
});

//Search modal focus input fiel when opened
$('#search').on('shown.bs.modal', function () {
    $('#search_field').focus();
});

$(document).ready(function() {  
		if( $("#voucher_amount").length){
			
			$('[data-zg-role="voucher_amount_custom"]').addClass('hidden');
			
			$( document ).on( 'click','[data-zg-role="voucher_amount"]',function(e){
				//e.stopPropagation();
				e.preventDefault();
				var value = $(this).data('value');
				
				if (value == 'amount'){
					$('[data-zg-role="voucher_amount_custom"]').removeClass('hidden');
					$('#voucher_amount').val('');
				}else{
					$('#voucher_amount').val(value);
					$('[data-zg-role="voucher_amount_custom"]').addClass('hidden');
				}
				
				$('[data-zg-role="voucher_amount"]').removeClass('active');
				$(this).addClass('active');
				

			}); 
		}


		if( $('[data-zg-role="gift_card_type"]').length){
			$( document ).on( 'click','[data-zg-role="gift_card_type"]',function(e){
				e.preventDefault();
				$('[data-zg-role="gift_card_type"]').removeClass('active');
				$(this).addClass('active');
				var value = $(this).data('value');
				$('#voucher_custom_fields_gift_card_type').val(value);
				$('#voucher_custom_fields_gift_card_type').valid();
			});
		}
	}); 

});



